<template>
    <th @click="emitSort" >
        {{label}}
        <span v-if="sortable" class='sort-buttons'>
            <font-awesome-icon v-if="!sorted" :icon="['fas', 'sort']" class="icon alt" />
            <span v-if="sorted">
                <font-awesome-icon v-if="sortedAsc === true"  :icon="['fas', 'sort-up']" class="icon alt" />
                <font-awesome-icon v-if="sortedAsc === false" :icon="['fas', 'sort-down']"   class="icon alt" />
            </span>
        </span>
    </th>
</template>

<script>
export default {
    props:{
        label:{
            type: String, 
            require: true
        },
        sortable: {
            type: Boolean,
            require: false,
            default: true
        },
        sorted:{
            type: Boolean,
            require: false,
            default: false
        },
        sortedAsc:{
            type: Boolean,
            require: false,
            default: false
        }
    },
    computed:{
        sort_class(){
            if(this.sortedAsc)
                return 'active-down';
            return 'active-up';
        }
    },
    methods: {
        emitSort(){
            if(this.sortable)
                this.$emit('sort')
        }
    }
}
</script>

<style>
.sort-buttons {
    margin-left: 5px;
}
</style>